import { IUseSignUpContext } from "@helper/react-context/context-hooks/use-sign-up-context";
import { Context } from "@helper/react-context/context-provider";
import { useContext } from "react";

// Hook for easier use of the specific context without the need to call useContext() and import the global Context itself.
const useSignUp = (): IUseSignUpContext => useContext(Context).signUp;

export default useSignUp;
